<template>
  <div style="display: flex" v-if="item.project">
    <div class="logo">
      <img
          :alt="item.project.name"
          :src="getLogoSrc(item.project.icon)">
    </div>
    <div class="title">
      <el-row>
        <el-col :span="24">
          <div class="name">{{ item.project.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <div class="info">版本号: {{ item.version }}</div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <div>更新时间: {{ item.release_at }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="12">
          <div v-if="item.project.developer" class="info">开发者: {{ item.project.developer }}</div>
        </el-col>
        <el-col v-if="item.project['privacy_policy']" :xs="24" :sm="24" :md="24" :lg="12">
          <div class="info">
            隐私政策:
            <el-link target="_blank" :href="item.project['privacy_policy']">点击查看</el-link>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {getLogoSrc} from "@/views/common/utils";

export default {
  name: 'DialogTitle',
  props: {
    item: {}
  },
  data() {
    return {
      getLogoSrc: getLogoSrc,
    }
  },
}
</script>

<style lang="scss" scoped>

.logo {
  max-height: 92px;
  min-width: 92px;
  overflow: hidden;

  img {
    max-height: 92px;
    max-width: 92px;
    border-radius: 18.4px;
  }
}

.title {
  margin: 9px 24px;
  color: #111111;
  width: 100%;

  .name {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .info {
    font-size: 1rem;

    /deep/ .el-link--inner {
      font-size: 1rem;
      margin-bottom: 3px;
    }
  }
}
</style>
